module.exports = __webpack_public_path__ + "static/media/galerija_2017 (13).b4249616.jpg";